import { ReactNode } from "react";
import styles from "@/pages/index.module.css";
import iconUrl from "@/images/icon_small.webp";
import { Link } from "react-router";

export function HowToPlay(): ReactNode {
  return (
    <div className={styles.howToPlayContainer}>
      <h1 className={styles.howToPlayHeader}>How to play</h1>
      <p>
        Draw the phrase at the top of the Notes for the pigeon to guess. Remember to make use of
        your tools:
      </p>
      <ul className={styles.howToPlayList}>
        <li>
          <span className={styles.howToPlayPalette}>Select colors</span> from the palette
        </li>
        <li>
          <span className={styles.howToPlayRestart}>Clear</span> your drawing from the top corner of
          the Notes
        </li>
        <li>
          <span className={styles.howToPlayEndRound}>End</span> the round early by stopping the
          timer
        </li>
      </ul>
      <p>
        If they guess the phrase correctly within the three timed rounds, you win. Come back daily
        for a new phrase!
      </p>
      <p className={styles.howToPlayMoreQuestions}>
        <Link to="/help">Have more questions?</Link>
        <img src={iconUrl} alt="pigeon" />
      </p>
    </div>
  );
}
